module.exports = __webpack_public_path__ + "static/img/52科学技术.ba89835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/52科学技术.jpg
// module id = kVbs
// module chunks = 0